import { BaseBigWinPopup } from './BaseBigWinPopup';
import { webSourceNames } from '../../../core/sourceNames';
import { webConfig } from '../../../core/applicationConfig';

export class BigWinWebPopup extends BaseBigWinPopup {
  execute({ root }) {
    const popup = this.getPopup({
      parentWidth: webConfig.width,
      parentHeight: webConfig.height,
      names: {
        wordTextureName: webSourceNames.bigWinWordsSpine,
        coinsTextureName: webSourceNames.bigWinCoinsSpine,
      },
      config: {
        position: webConfig.staticAnimationPosition,
        textPosition: { x: webConfig.width / 2 + 50, y: 720 },
      },
    });
    root.addChild(popup);
  }
}
